/**
 * karmabooking-api
 *
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2020 Karmabunny
 */

import './sanity';
import * as api from './api';

export * from './gettext';
export * from './api';
export default api;

export {
    isApiError, isTimeoutError,
    assertApiError, assertTimeoutError
} from './errors';

declare global {
    interface Window {
        __config: Config;
        __translations: Translations;
        __marketing: Marketing;
    }
}

// See: karmabooking-plugin/src/models/Settings.php
export interface Config {
    prefix: string; // base path for vue app
    url: string; // api url
    key: string; // license key
    site: string;
    language_options: string[];
    environment: string;
    registration_fee: number;

}

export interface Marketing {
    action: MarketingOption[];
    source: MarketingOption[];
}

export interface MarketingOption {
    value: string;
    label: string;
    type: '' | 'free-text' | 'sub-list';
    sub_label: string;
    sub_options: string[];
}

export interface Translations {
    lang: string;
    name: string;
    tr: Record<string, string | string[]>;
    plurals: Record<string, number>;
}
